import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'live/services/i18n'
import RigSupervisorsTableForm from './rig-supervisors-table-form'
import Utils from 'live/lib/utils'

RigsSupervisorsView.displayName = 'RigsSupervisorsView'
RigsSupervisorsView.propTypes = {
    showTitle: PropTypes.bool,
    headerAddon: PropTypes.element,
    rigLists: PropTypes.shape({
        arap: PropTypes.array.isRequired,
        aup: PropTypes.array.isRequired,
        exp: PropTypes.array.isRequired
    }).isRequired,
    rigsConfig: PropTypes.shape({
        nSupervisorsARAP: PropTypes.number,
        nSupervisorsAUP: PropTypes.number,
        nSupervisorsEXP: PropTypes.number,
        percentageOfFloatingARAPRigsWith3Supervisors: PropTypes.number,
        percentageOfFloatingAUPRigsWith3Supervisors: PropTypes.number,
        percentageOfFloatingEXPRigsWith3Supervisors: PropTypes.number
    }).isRequired
}

export default function RigsSupervisorsView (props) {
    const i18nFloatingRigWith3Supervisors = i18n('of floating rigs with 3 supervisors')
    const { rigsConfig = {}, rigLists, showTitle, headerAddon = null } = props

    let clsARAP = 'percentageOfRigsWith3Supervisors'
    let clsAUP = 'percentageOfRigsWith3Supervisors'
    let clsEXP = 'percentageOfRigsWith3Supervisors'

    if (rigsConfig.percentageOfFloatingARAPRigsWith3Supervisors < 0) clsARAP += ' error'

    if (rigsConfig.percentageOfFloatingAUPRigsWith3Supervisors < 0) clsAUP += ' error'

    if (rigsConfig.percentageOfFloatingEXPRigsWith3Supervisors < 0) clsEXP += ' error'

    return (
        <div className="rigs-supervisor-view">
            <h4>{showTitle && i18n('Number of supervisors by area').toUpperCase()}</h4>
            <div className="supervisors-by-area">
                <div>
                    <label className="supervisorsLabel">{i18n('ARAP rig supervisors')}</label>
                    <label className="nSupervisorsLabel">{rigsConfig.nSupervisorsARAP}</label>
                    <label className={clsARAP}>
                        {Utils.formatNumber(rigsConfig.percentageOfFloatingARAPRigsWith3Supervisors, 2, 2)}%{' '}
                        {i18nFloatingRigWith3Supervisors}
                    </label>
                </div>
                <div>
                    <label className="supervisorsLabel">{i18n('AUP rig supervisors')}</label>
                    <label className="nSupervisorsLabel">{rigsConfig.nSupervisorsAUP}</label>
                    <label className={clsAUP}>
                        {Utils.formatNumber(rigsConfig.percentageOfFloatingAUPRigsWith3Supervisors, 2, 2)}%{' '}
                        {i18nFloatingRigWith3Supervisors}
                    </label>
                </div>
                <div>
                    <label className="supervisorsLabel">{i18n('Exploratory rig supervisors')}</label>
                    <label className="nSupervisorsLabel">{rigsConfig.nSupervisorsEXP}</label>
                    <label className={clsEXP}>
                        {Utils.formatNumber(rigsConfig.percentageOfFloatingEXPRigsWith3Supervisors, 2, 2)}%{' '}
                        {i18nFloatingRigWith3Supervisors}
                    </label>
                </div>
                {headerAddon}
            </div>

            <hr />

            <div className="rigs-supervisor-view__rigs-container">
                <div className="rigs-supervisor-view__table-title">
                    <h3>{i18n('ARAP rigs')}</h3>
                    <span>
                        6 {i18n('rigs')} | 15 {i18n('supervisors')} | 50% {i18nFloatingRigWith3Supervisors}
                    </span>
                </div>
                <RigSupervisorsTableForm
                    fields={tableConfig}
                    data={rigLists.arap}
                    hasClear={false}
                    hideAddButton={true}
                />

                <div className="rigs-supervisor-view__table-title">
                    <h3>{i18n('AUP rigs')}</h3>
                </div>
                <RigSupervisorsTableForm
                    fields={tableConfig}
                    data={rigLists.aup}
                    hasClear={false}
                    hideAddButton={true}
                />

                <div className="rigs-supervisor-view__table-title">
                    <h3>{i18n('Exploratory rigs')}</h3>
                </div>
                <RigSupervisorsTableForm
                    fields={tableConfig}
                    data={rigLists.exp}
                    hasClear={false}
                    hideAddButton={true}
                />
            </div>
        </div>
    )
}

const tableConfig = [
    {
        label: i18n('RIG'),
        name: 'label-name',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('EXP / ARAP / AUP'),
        name: 'area',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('FIXED / FLOATING'),
        name: 'label-installationType',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('TYPE'),
        name: 'label-rigType',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('PENTAGON'),
        name: 'label-pentagonCoefficient',
        type: 'readonly',
        cols: 2
    },
    {
        label: i18n('PRIORITY'),
        name: 'priority',
        type: 'readonly',
        cols: 1
    },
    {
        label: i18n('SUPERVISORS'),
        name: 'nSupervisors',
        type: 'readonly',
        cols: 1
    }
]
